<template>
  <div class="c-filter">
    <div class="c-form">
      <Form inline>
        <FormItem :label-width="0" class="g-pull-right">
          <Button type="primary" @click="down">数据导出</Button>
        </FormItem>
        <FormItem :label-width="56" label="月份：" class="g-pull-left">
          {{ month }}
        </FormItem>
        <FormItem :label-width="56" label="姓名：" class="g-pull-left">
          {{ designerName }}
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { HOST_API } from '@/api/config'

export default {
  name: 'designerDetailFilter',
  props: {
    month: {
      type: String
    },
    designerId: {
      type: [String, Number]
    },
    designerName: {
      type: String
    }
  },
  methods: {
    down() {
      let url = `${HOST_API}/api/ptom/designer/exportDesignDetailInfo`
      url += `?month=${this.month}`
      url += `&designerId=${this.designerId}`
      url += `&designerName=${this.designerName}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.c-filter {
  width: 100%;
  padding-top: 8px;
  display: flex;
  background-color: #f2f2f2;

  .c-form {
    width: 100%;
    flex: 0 0 auto;
    text-align: right;
    padding: 0 8px;

    ::v-deep .ivu-form-item {
      margin-bottom: 8px;
      text-align: left;
    }
  }
}
</style>
